import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    lists: {
        plants: [],
        halls: [],
        lines: [],
        machines: [],
        shifts: []
    }, //Array of all lists
    current: {
        plant: null,
        hall: null,
        line: null,
        machine: null,
        shift: null,
        shiftDate: null,
        role: null,
        sideOptions: [],
        sideKey: null
    }
}

export const plantSlice = createSlice({
    name: 'plant',
    initialState,
    reducers: {
        setPlantsList: (state, { payload }) => {
            let { allPlants, current, halls, lines, machines } = payload;
            // State
            state.lists.plants = allPlants
            state.lists.halls = halls
            state.lists.lines = lines
            state.lists.machines = machines
            state.current = current
        },
        changePlant: (state, { payload }) => {
            let { halls, lines, machines, current } = payload;
            state.current = current
            state.lists.halls = halls
            state.lists.lines = lines
            state.lists.machines = machines
        },
        changeHall: (state, { payload }) => {
            let { selectedHall } = payload;
            state.current.hall = selectedHall
        },
        changeLine: (state, { payload }) => {
            let { selectedLine, machines, selectedMachine } = payload;
            state.lists.machines = machines
            state.current.line = selectedLine
            state.current.machine = selectedMachine
            state.current.shift = selectedLine?.shifts?.length ? selectedLine?.shifts[0] : []
        },
        changeMachine: (state, { payload }) => {
            let { selectedMachine } = payload;
            state.current.machine = selectedMachine
        },
        changeShift: (state, { payload }) => {
            let { selectedShift } = payload;
            state.current.shift = selectedShift
        },
        changeShiftDate: (state, { payload }) => {
            state.current.shiftDate = payload
        },
        changeAccessControl: (state, { payload }) => {
            let { current, plants } = payload;
            state.current = current
            state.lists.plants = plants
        },
        changePlants: (state, { payload }) => {
            let { newPlants, newPlant } = payload;
            state.current.plant = newPlant
            state.lists.plants = newPlants
        },
        changeSideOptions: (state, { payload }) => {
            let { options } = payload;
            state.current.sideOptions = options
        },
        changeRole: (state, { payload }) => {
            let { role } = payload;
            state.current.role = role
        },
        changeKey: (state, { payload }) => {
            let { key, data } = payload;
            state.current[key] = data
        },
        updateList: (state, { payload }) => {
            let { key, data } = payload;
            state.lists[key] = data
        },
        changeValidation: (state, { payload }) => {
            let { current, plants } = payload;
            state.current = current
            state.lists.plants = plants
        },
        updateShifts: (state, { payload }) => {
            state.lists.shifts = payload || [];
            state.current.shift = payload?.[0];
        },
        clearPlant: (state, action) => initialState
    },
})

// Action creators are generated for each case reducer function
export const { updateShifts, updateList, changeShiftDate, changePlant, changeHall, changeLine, changeMachine, setPlantsList, changeShift, changeAccessControl, changeValidation, changePlants, clearPlant, changeSideOptions, changeRole, changeKey } = plantSlice.actions
export default plantSlice.reducer